/**
 * description 设置编辑记录
 * @param {string} moduleName - 记录的模块名称
 * @param {any} val - 编辑状态标识
 */
export function setEditRecord(moduleName, val) {
    if (!moduleName) return;
    const obj = JSON.parse(sessionStorage.getItem('isEdit-InvoiceManageDetails') || '{}');
    obj[moduleName] = val;
    sessionStorage.setItem('isEdit-InvoiceManageDetails', JSON.stringify(obj));
}
/**
 * description 获取编辑记录
 * @param {string} moduleName - 记录的模块名称
 */
export function getEditRecord(moduleName) {
    if (!moduleName) return null;
    const obj = JSON.parse(sessionStorage.getItem('isEdit-InvoiceManageDetails') || '{}');
    return obj[moduleName] || null;
}
/**
 * description 是否编辑
 * @param {string} moduleName - 记录的模块名称
 */
export function isEdit(moduleName) {
    let obj = JSON.parse(sessionStorage.getItem('isEdit-InvoiceManageDetails') || '{}');
    moduleName && (obj = { [moduleName]: obj[moduleName] });
    return isObject(obj) && isEditVerify(obj);
}

/**
 * description 移除编辑记录
 */
export function removeEditRecord(moduleName, val) {
    sessionStorage.removeItem('isEdit-InvoiceManageDetails');
}

function isEditVerify(obj) {
    for (const key in obj) {
        // 检查属性值是否为 false、'0' 或 'false'
        if (obj.hasOwnProperty(key) && !(obj[key] === false || obj[key] === '0' || obj[key] === 'false')) {
            // 如果找到任何匹配项，则返回 true
            return true;
        }
    }
    // 如果没有找到匹配项，则返回 false
    return false;
}

function isObject(input) {
    return typeof input === 'object' && input !== null;
}
